import request from '../../utils/axios';

const publicPrefix = '/public';

/**
 * 提交检测报告智能审核（multipart: file + modelType）
 */
export const submitReportReview = (data) => request.post(`${publicPrefix}/reportReview/submit`, data);

/**
 * 查询审核结果（轮询）
 */
export const getReportReview = (params) => request.get(`${publicPrefix}/reportReview/get`, { params });

/**
 * 我的审核记录列表
 */
export const getReportReviewList = (params) => request.get(`${publicPrefix}/reportReview/list`, { params });

/**
 * 可用大模型列表
 */
export const getReviewModels = (params) => request.get(`${publicPrefix}/reportReview/models`, { params });